import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import type { ElForm } from "element-ui/types/form";
import { cloneDeep } from "lodash";
import style from "./style.vue";
import Upload from "@/views/components/upload/upload.vue";
import { IPSService } from "@/services/ipsServices";
import ChooseGoodsClass from "@/views/components/chooseGoodsClass";
import selectGoods from "@/views/components/selectGoods";
import { noop, showPlatform } from "@/util";
import validateParams from "@/library/utils/paramFilter";
import { Functions } from "@/library/utils/functions";
import couponLink, { CRMCouponType } from "@/views/components/linkForm/coupon";
import CouponCard from "@/views/components/couponsManager/couponCard";

interface ProductInfo {
	productCode?: string; // 货号
	productShowName?: string; // 商品显示名
	productName?: string; // 商品显示名
	classIds?: number[]; // 分类Id
	skuItems?: Array<{ sku?: string; specVal?: string; stock?: number }>; // 规格列表
	productMainImage?: { isDefault?: 0 | 1; mainImage?: string; mainImages?: string[] }; // 主图
	infoImage?: { isDefault?: 0 | 1; infoImage?: string[] }; // 详情图
	colorImages?: { isDefault?: 0 | 1; colorImage?: { colorCode?: string; image?: string }[] }; // 色图
	colorItems?: Array<{ colorCode?: string; colorName?: string }>;
	openState?: 0 | 1; // 上下架状态 0 下架 1 上架
	siteId?: number; // 网点Id
	productId?: number; // 商品Id
	originPrice?: number; // 牌价
	price?: number; // 现价
	vendorProductInfo?: VendorProductInfo;
	isDrp: number | boolean; // 是否使用DRP数据 1:使用 0:不使用
	productType: number; // 0正常商品 1赠品
	productConfig?: {
		minOrderPrice: number; // 整单满多少元可下单
		cplId: string; // 顾客拥有指定优惠券可下单
	};
}

interface VendorProductInfo {
	productImage?: string;
	productMainImages?: string[];
	productImages?: string[];
	colorInfo?: { colorCode?: string; colorName?: string; iamge?: string }[];
}

interface ClolorImage {
	isDefault?: 0 | 1;
	colorImage?: { colorCode?: string; image?: string }[];
}

@Component({
	mixins: [style],
})
export default class AddProduct extends Vue {
	@Prop()
	productId: number;

	$refs: {
		pAddForm: ElForm;
	};

	// 商品数据
	pInfo: ProductInfo = {
		productCode: "",
		productShowName: "",
		productName: "",
		classIds: [],
		skuItems: [],
		isDrp: 0 || false,
		productMainImage: {
			isDefault: 0,
			mainImage: "",
			mainImages: [],
		},
		infoImage: {
			isDefault: 0,
			infoImage: [],
		},
		colorImages: {
			isDefault: 0,
			colorImage: [],
		},
		colorItems: [],
		openState: 1,
		siteId: 0,
		productId: 0,
		originPrice: 10.02,
		price: 8.05,
		productType: 0,
		productConfig: {
			minOrderPrice: 0,
			cplId: "",
		},
	};

	// 校验规则
	rules = {
		product: [{ required: true, validator: this.validateProduct, trigger: "change" }],
		pClass: [{ validator: this.validateClass, trigger: "change" }],
		productShowName: [{ required: false, validator: this.validateProductName, trigger: "change" }],
		mainImage: [{ validator: this.validateMainImage, trigger: "change" }],
	};

	// 保存按钮禁用
	disabled = false;

	// 商品条码跟新禁用

	disabledSku = false;

	// 网点Id
	siteId = 0;

	// 网点分类列表
	siteClassList = [];

	// 商品默认图片
	vendorProductInfo: VendorProductInfo = {
		productImage: "",
		productMainImages: [],
		productImages: [],
		colorInfo: [],
	};

	// 显示图片
	displayMainImage = "";
	displayMainImages: string[] = [];

	displayInfoImage = [];

	dispalyColorImages = [];

	isImages = false;

	enterTime = 0;

	saveTime = 0;

	// 赠品条件是否开启
	productConfigOpen = false;

	// 顾客拥有指定礼品券开启
	hasCoupon = false;

	couponCardInfo = {};

	async mounted() {
		this.enterTime = Date.now();
		console.log("进入时间", this.enterTime);
		this.siteId = Number(this.$route.params.siteId);
		if (showPlatform()) {
			// @ts-expect-error
			this.rules = { ...this.rules, "productConfig.minOrderPrice": [{ validator: this.validateGift, trigger: "change" }], "productConfig.cplId": [{ validator: this.validateCoupon, trigger: ["change", "blur"] }] };
		}
		this.pInfo.siteId = this.siteId;
		this.productId && this.getInfo();
		// this.siteClassList = await this.getClass();
	}

	getClass() {
		return IPSService.siteClassList({
			postParams: {
				siteId: this.siteId,
			},
		}).then((response) => {
			return response.list || [];
		});
	}

	validateMainImage(rule, value, callback) {
		if (this.pInfo.productMainImage.isDefault && (!this.pInfo.productMainImage.mainImage || !this.pInfo.productMainImage.mainImage.length)) {
			callback(new Error("请上传商品主图"));
		} else {
			callback();
		}
	}

	validateMainImages(rule, value, callback) {
		if (this.pInfo.productMainImage.isDefault && (!this.pInfo.productMainImage.mainImages || !this.pInfo.productMainImage.mainImages.length)) {
			callback(new Error("请上传商品主图"));
		} else {
			callback();
		}
	}

	validateProduct(rule, value, callback) {
		if (!this.pInfo.productCode || !this.pInfo.productCode.trim()) {
			callback(new Error("请选择商品"));
		} else {
			callback();
		}
	}

	validateProductName(rule, value, callback) {
		if (!this.pInfo.isDrp && this.pInfo.productShowName && this.pInfo.productShowName.length > 50) {
			callback(new Error(" "));
		} else {
			callback();
		}
	}

	validateGift(rule, value, callback) {
		if (this.pInfo?.productType && this.productConfigOpen && !this.pInfo?.productConfig?.minOrderPrice) {
			callback(new Error(" "));
		} else {
			callback();
		}
	}

	validateCoupon(rule, value, callback) {
		if (this.pInfo?.productType && this.hasCoupon && !this.pInfo?.productConfig?.cplId) {
			callback(new Error("请选择优惠券"));
		} else {
			callback();
		}
	}

	validateClass(rule, value, callback) {
		if (!this.pInfo.classIds || !this.pInfo.classIds.length) {
			callback(new Error("请选择商品分类"));
		} else {
			callback();
		}
	}

	//   获取详情
	getInfo() {
		const loading = this.$loading({
			lock: true,
			text: "请稍等...",
			spinner: "el-icon-loading",
			background: "rgba(225,225,225,0.3)",
			target: ".p-edit-container",
		});
		IPSService.siteProductInfo({
			postParams: {
				productId: this.productId,
				siteId: this.siteId,
			},
		}).then(
			async (response: any) => {
				this.pInfo = Object.assign({}, this.pInfo, response);
				this.pInfo.siteId = this.siteId;
				if (this.pInfo?.productType && showPlatform()) {
					this.productConfigOpen = !!this.pInfo?.productConfig?.minOrderPrice;
					this.hasCoupon = !!this.pInfo?.productConfig?.cplId;
					this.hasCoupon && this.getCrmCouponInfo(this.pInfo.productConfig.cplId);
				}
				this.vendorProductInfo = cloneDeep(response.vendorProductInfo || {});
				if (this.vendorProductInfo.productMainImages && this.vendorProductInfo.productMainImages.length) {
					this.isImages = true;
					this.rules["mainImages"] = [
						{
							required: true,
							validator: this.validateMainImages,
							trigger: ["change", "blur"],
						},
					];
					if (!this.pInfo.productMainImage.isDefault) {
						this.displayMainImages = cloneDeep(this.vendorProductInfo.productMainImages) || [];
						this.displayMainImage = this.vendorProductInfo.productImage || "";
					} else {
						this.displayMainImages = cloneDeep(this.pInfo.productMainImage.mainImages);
						this.displayMainImage = this.pInfo.productMainImage.mainImage || "";
					}
				} else {
					this.isImages = false;
					if (!this.pInfo.productMainImage.isDefault) {
						this.displayMainImage = this.vendorProductInfo.productImage || "";
					} else {
						this.displayMainImage = this.pInfo.productMainImage.mainImage || "";
					}
				}

				if (!this.pInfo.infoImage.isDefault) {
					this.displayInfoImage = cloneDeep(this.vendorProductInfo.productImages) || [];
				} else {
					this.displayInfoImage = cloneDeep(this.pInfo.infoImage.infoImage) || [];
				}
				if (!this.pInfo.colorImages.isDefault) {
					this.dispalyColorImages = cloneDeep(this.vendorProductInfo.colorInfo) || [];
				} else {
					this.dispalyColorImages = cloneDeep(this.pInfo.colorImages.colorImage) || [];
				}
				let stock = 0;
				let saleNum = 0;
				this.pInfo.skuItems.forEach((v) => {
					stock += v.stock;
					saleNum += (v as any).saleNum;
				});
				const count = {
					goodsSku: "合计",
					stock,
					saleNum,
				};
				this.pInfo.skuItems.push(count);
				loading.close();
			},
			() => {
				loading.close();
			},
		);
	}

	// 选择商品
	onSelectProduct() {
		selectGoods.open({ multiple: false, showBD: false, siteId: this.siteId }).then(async (result) => {
			if (result && result.list && result.list[0]) {
				this.pInfo.isDrp = true || 1;
				this.pInfo.productCode = result.list[0].productCode;
				this.pInfo.productName = result.list[0].productName;
				this.pInfo.productShowName = result.list[0].productFullName;
				this.pInfo.price = result.list[0].price;
				this.pInfo.originPrice = result.list[0].originPrice;
				// this.pInfo.productShowName = result.list[0].productName;

				this.pInfo.skuItems = result.list[0].skuItems;
				let stock = 0;
				let saleNum = 0;
				this.pInfo.skuItems.forEach((v) => {
					stock += v.stock;
					saleNum += (v as any).saleNum;
				});
				const count = {
					goodsSku: "合计",
					stock,
					saleNum,
				};
				this.pInfo.skuItems.push(count);
				// 商品初始值
				this.pInfo.productMainImage.mainImage = "";
				this.pInfo.productMainImage.mainImages = [];
				this.pInfo.infoImage.infoImage = [];
				this.pInfo.colorItems = result.list[0].colorItems;
				result.list[0].colorImages = result.list[0].colorImages.map((val) => {
					return Object.assign({}, { ...val }, { colorName: this.getColorName(val.colorCode) });
				});
				this.pInfo.colorImages.colorImage = (result.list[0].colorImages || []).map((v) => Object.assign({}, { ...v }, { image: "" }));

				// 默认值
				this.vendorProductInfo.productImage = result.list[0].productImage;

				this.vendorProductInfo.productMainImages = cloneDeep(result.list[0].productMainImages) || [result.list[0].productImage];
				this.vendorProductInfo.productImages = cloneDeep(result.list[0].productImages);
				this.vendorProductInfo.colorInfo = cloneDeep(result.list[0].colorImages);
				if (this.vendorProductInfo.productMainImages && this.vendorProductInfo.productMainImages.length) {
					this.isImages = true;
					this.rules["mainImages"] = [
						{
							required: true,
							validator: this.validateMainImages,
							trigger: ["change", "blur"],
						},
					];
					if (this.pInfo.productMainImage.isDefault) {
						this.displayMainImages = cloneDeep(this.vendorProductInfo.productMainImages);
					} else {
						this.displayMainImages = result.list[0].productMainImages || [];
					}
				}

				if (this.pInfo.productMainImage.isDefault) {
					this.displayMainImage = this.vendorProductInfo.productImage;
				} else {
					this.displayMainImage = result.list[0].productImage;
				}

				if (this.pInfo.infoImage.isDefault) {
					this.displayInfoImage = cloneDeep(this.vendorProductInfo.productImages);
				} else {
					this.displayInfoImage = cloneDeep(result.list[0].productImages || []);
				}

				if (this.pInfo.colorImages.isDefault) {
					this.dispalyColorImages = cloneDeep(this.vendorProductInfo.colorInfo);
				} else {
					this.dispalyColorImages = cloneDeep(result.list[0].colorImages || []);
				}
				this.$forceUpdate();
			}
		}, noop);
	}

	// 上传成功
	uploadSuccess(val, fieldKey, i?) {
		fieldKey && this.$refs.pAddForm.validateField(fieldKey, noop);
	}

	uploadMainImageSuccess(val) {
		this.pInfo.productMainImage.mainImage = val.content;
		this.pInfo.productMainImage.mainImages = [val.content];
	}

	uploadMainImagesSuccess(val) {
		this.pInfo.productMainImage.mainImages = cloneDeep(this.displayMainImages);
	}

	uploadInfoImageSuccess(val) {
		this.pInfo.infoImage.infoImage = cloneDeep(this.displayInfoImage);
	}

	uploadColorImageSuccess(val, index) {
		if (this.pInfo.colorImages.colorImage[index]) {
			this.pInfo.colorImages.colorImage[index].image = val.content;
		}
	}

	// 取消
	onCancel() {
		this.$confirm("是否取消本次编辑?", { type: "warning" }).then((result) => {
			if (result === "confirm") {
				this.$emit("back");
			}
		}, noop);
	}

	getImage(list, oriList) {
		const newList = oriList
			.filter((item) => {
				return list.includes(item.key);
			})
			.map((i) => i.value);
		return newList;
	}

	// 保存
	onSave() {
		this.saveTime = Date.now();
		console.log("保存时间", this.saveTime);
		if ((this.saveTime - this.enterTime) / 1000 < 3000) {
			this.$refs.pAddForm.validate((result) => {
				if (result) {
					this.disabled = true;
					if (!this.hasCoupon) {
						this.pInfo.productConfig.cplId = "";
					}
					if (!this.productConfigOpen) {
						this.pInfo.productConfig.minOrderPrice = 0;
					}
					const postParams = cloneDeep(this.pInfo);
					const colorImage = this.dispalyColorImages[0]?.image;
					const list = [this.displayMainImage].concat(this.displayMainImages).concat(this.displayInfoImage).concat(colorImage).filter(Boolean);
					IPSService.picsChange({ postParams: { fileUrls: validateParams(list) } })
						.then((res) => {
							const picList = Object.keys(res.info).map((k) => {
								return Object.assign({}, { key: k, value: res.info[k] });
							});
							if (!postParams.productMainImage.isDefault) {
								postParams.productMainImage.mainImage = this.getImage([this.vendorProductInfo.productImage], picList).toString() || this.vendorProductInfo.productImage;
								postParams.productMainImage.mainImages = this.getImage(this.vendorProductInfo.productMainImages, picList) || this.vendorProductInfo.productMainImages;
							}
							if (!postParams.infoImage.isDefault) {
								postParams.infoImage.infoImage = this.getImage(this.vendorProductInfo.productImages, picList) || this.vendorProductInfo.productImages;
							}

							if (!postParams.colorImages.isDefault) {
								postParams.colorImages.colorImage = this.vendorProductInfo.colorInfo;
							}
							if (this.productId) {
								this.pInfo.openState = null;
							}
							// 葛少华说 库存取接口传的值
							postParams.skuItems.pop();

							IPSService.siteProductManageAdd({
								postParams,
							}).then(
								(response) => {
									this.disabled = false;
									this.$message.success(`${this.productId ? "保存" : "添加"}成功`);
									this.$emit("back");
								},
								() => {
									this.disabled = false;
								},
							);
						})
						.catch((error) => {
							console.log(error);
							this.disabled = false;
						});
				} else {
					this.$nextTick(() => {
						if (this.$el.querySelector(".el-form-item__error")) {
							this.$el.querySelector(".el-form-item__error").scrollIntoView({ behavior: "smooth", block: "center" });
						}
					});
				}
			});
		} else {
			this.$message.warning("已超过规定时间，请等待数据刷新后重试");
			this.productId && this.getInfo();
		}
	}

	// 主图切换
	mainImageChange(val) {
		if (!val) {
			this.displayMainImage = this.vendorProductInfo.productImage;
		} else {
			this.displayMainImage = this.pInfo.productMainImage.mainImage;
		}
	}

	mainImagesChange(val) {
		if (!val) {
			this.displayMainImages = cloneDeep(this.vendorProductInfo.productMainImages);
		} else {
			this.displayMainImages = cloneDeep(this.pInfo.productMainImage.mainImages);
		}
	}

	// 详情图片切换
	infoImageChange(val) {
		if (!val) {
			this.displayInfoImage = cloneDeep(this.vendorProductInfo.productImages);
		} else {
			this.displayInfoImage = cloneDeep(this.pInfo.infoImage.infoImage);
		}
	}

	// 颜色图片
	colorImageChange(val) {
		if (!val) {
			this.dispalyColorImages = cloneDeep(this.vendorProductInfo.colorInfo);
		} else {
			this.dispalyColorImages = cloneDeep(this.pInfo.colorImages.colorImage);
		}
	}

	getColorName(colorCode) {
		const result = this.pInfo.colorItems.find((val) => val.colorCode === colorCode);
		return result ? result.colorName || "" : "";
	}

	onRemoveInfoImage(url, i) {
		this.pInfo.infoImage.infoImage = cloneDeep(url);
	}

	onRemoveMainImage(url, i) {
		this.pInfo.productMainImage.mainImages = cloneDeep(url);
	}

	onSortMainImages(val) {
		if (this.pInfo.productMainImage.isDefault) {
			this.pInfo.productMainImage.mainImages = cloneDeep(val);
		}
	}

	onSortInfoImage(val) {
		if (this.pInfo.infoImage.isDefault) {
			this.pInfo.infoImage.infoImage = cloneDeep(val);
		}
	}

	onSortColorImage(val, index) {
		this.dispalyColorImages[index].image = cloneDeep(val);
		this.pInfo.colorImages.colorImage = cloneDeep(this.dispalyColorImages);
	}

	// 选择优惠券
	chooseCoupon() {
		couponLink
			.open({
				siteCodes: [this.$route.params.code],
				params: { isIps: 1, unlimited: true, cpnType: CRMCouponType.COUPON_GIFT },
			})
			.then((result) => {
				this.pInfo.productConfig.cplId = result.id;
				this.getCrmCouponInfo(result.id);
			}, noop);
	}

	/**
	 * 获取crm优惠券详情
	 * @param cplId
	 */
	getCrmCouponInfo(cplId: string) {
		IPSService.crmCouponIfo({
			postParams: {
				siteId: this.siteId,
				cplId,
			},
		}).then((response) => {
			this.couponCardInfo = Object.assign({}, { cplId }, response);
		});
	}

	// 更新商品条码
	upDateSkus() {
		this.disabled = true;
		IPSService.updateProductSkus({ postParams: { productCode: this.pInfo.productCode } }).then((res) => {
			const { siteCodes, notFoundSiteCodes, successSiteCodes, errorSiteCodes } = res.siteRetInfo;
			const message =
				siteCodes.length === successSiteCodes.length
					? `${successSiteCodes.length}家店铺刷新成功`
					: `${successSiteCodes.length}家店铺刷新成功,${errorSiteCodes
							.concat(notFoundSiteCodes)
							.map((i) => i)
							.join(",")}店铺刷新失败`;
			this.$confirm(`${message}`, { confirmButtonText: "确定", showCancelButton: false })
				.then(() => {
					this.disabledSku = false;
					this.productId && this.getInfo();
				})
				.catch(() => {
					this.disabledSku = false;
					this.productId && this.getInfo();
				});
		});
	}

	render(h) {
		return (
			<div class="p-edit-container">
				<div class="p-edit-content">
					<div class="blockTitle">{this.productId ? "编辑商品" : "添加商品"}</div>
					<el-form props={{ model: this.pInfo }} label-position="left" label-width="100px" rules={this.rules} ref="pAddForm">
						{!this.productId && (
							<el-form-item label="选择商品" prop="product">
								<el-button type="primary" onClick={this.onSelectProduct.bind(this)} disabled={!!this.productId}>
									选择商品
								</el-button>
							</el-form-item>
						)}
						<el-form-item label="商品货号" prop="productCode">
							<p>{this.pInfo.productCode}</p>
						</el-form-item>
						<el-form-item label="商品名称" prop="productName">
							<p>{this.pInfo.productName}</p>
						</el-form-item>
						<el-form-item label="商品展示名" prop="productShowName">
							<el-input v-model={this.pInfo.productShowName} maxlength={50} disabled={!!this.pInfo.isDrp} show-word-limit style="width: 50%" />
							<el-checkbox true-label={1} false-label={0} v-model={this.pInfo.isDrp} class="r-ml-14">
								使用DRP数据
							</el-checkbox>
							<br />
							<span class="tip">
								<span class="redText">*&nbsp;</span>&nbsp;如配置商品展示名,则商品列表及商品详情中,将展现该名称。
							</span>
						</el-form-item>
						<br />
						<el-form-item label="商品明细" prop="">
							<div class="p-sku">
								<el-table tooltip-effect="light" data={this.pInfo.skuItems}>
									<el-table-column prop="goodsSku" label="条码" show-overflow-tooltip={true} />
									<el-table-column prop="specVal" label="规格" show-overflow-tooltip />
									<el-table-column
										prop="originPrice"
										label="牌价(元)"
										align="right"
										show-overflow-tooltip
										{...{
											scopedSlots: {
												default: (scope) => {
													return <span>{scope.row.originPrice === undefined ? "" : `￥${scope.row.originPrice}`}</span>;
												},
											},
										}}
									/>
									<el-table-column
										prop="price"
										label="现价(元)"
										align="right"
										show-overflow-tooltip
										{...{
											scopedSlots: {
												default: (scope) => {
													return <span>{scope.row.price === undefined ? "" : `￥${scope.row.price}`}</span>;
												},
											},
										}}
									/>
									<el-table-column prop="stock" label="库存" align="right" />
									<el-table-column prop="saleNum" label="销量" align="right" />
								</el-table>
							</div>
							{!!this.productId && (
								<span class={["scopeSpan", this.disabledSku && "disabled"]} onClick={this.upDateSkus.bind(this)}>
									更新商品条码
								</span>
							)}
						</el-form-item>
						{this.isImages ? (
							<el-form-item label="商品主图" prop="mainImages">
								<el-radio-group v-model={this.pInfo.productMainImage.isDefault} onChange={(val) => this.mainImagesChange(val)}>
									<el-radio label={0}>使用默认商品主图</el-radio>
									<el-radio label={1}>自行上传商品主图</el-radio>
								</el-radio-group>
								<Upload
									fileList={true}
									sort={!this.pInfo.productMainImage.isDefault}
									disabled={!this.pInfo.productMainImage.isDefault}
									onImgUploadSuccess={(val) => this.uploadMainImagesSuccess(val)}
									v-model={this.displayMainImages}
									onDelete={(url, i) => this.onRemoveMainImage(url, i)}
									onSort={(val) => this.onSortMainImages(val)}
									maxSize={2048}
									maxLen={9}
								/>
								{(!this.displayMainImages || !this.displayMainImages.length) && !this.pInfo.productMainImage.isDefault && this.pInfo.productCode && <el-image src="https://ssl-picture.tenyun.runsasoft.com/wumorentu.png" style="width: 150px" />}
								{!!this.pInfo.productMainImage.isDefault && [
									<div class="tip">注1: 建议图片分辨率为750*750px;</div>,
									<div class="tip">注2: 每张图片大小不超过2M,支持jpg、jpeg、png、gif,最多支持上传9张;</div>,
									<div class="tip">注3: 拖拽图片可排序，第一张图将作为商品列表画面所展示的图片。</div>,
								]}
							</el-form-item>
						) : (
							<el-form-item label="商品主图" prop="mainImage">
								<el-radio-group v-model={this.pInfo.productMainImage.isDefault} onChange={(val) => this.mainImageChange(val)}>
									<el-radio label={0}>使用默认商品主图</el-radio>
									<el-radio label={1}>自行上传商品主图</el-radio>
								</el-radio-group>
								<Upload fileList={false} disabled={!this.pInfo.productMainImage.isDefault} onImgUploadSuccess={(val) => this.uploadMainImageSuccess(val)} v-model={this.displayMainImage} maxSize={2048} />
								{(!this.displayMainImage || !this.displayMainImage.length) && !this.pInfo.productMainImage.isDefault && this.pInfo.productCode && <el-image src="https://ssl-picture.tenyun.runsasoft.com/wumorentu.png" style="width: 150px" />}
								{!!this.pInfo.productMainImage.isDefault && [
									<div class="tip">注1: 建议图片分辨率为750*750px;</div>,
									<div class="tip">注2: 每张图片大小不超过2M,支持jpg、jpeg、png、gif,最多支持上传9张;</div>,
									<div class="tip">注3: 拖拽图片可排序，第一张图将作为商品列表画面所展示的图片。</div>,
								]}
							</el-form-item>
						)}
						<el-form-item label="商品详情图" prop="">
							<el-radio-group v-model={this.pInfo.infoImage.isDefault} onChange={(val) => this.infoImageChange(val)}>
								<el-radio label={0}>使用默认商品详情图</el-radio>
								<el-radio label={1}>自行上传商品详情图</el-radio>
							</el-radio-group>
							<Upload
								fileList={true}
								sort={!this.pInfo.infoImage.isDefault}
								disabled={!this.pInfo.infoImage.isDefault}
								onImgUploadSuccess={(val) => this.uploadInfoImageSuccess(val)}
								v-model={this.displayInfoImage}
								onDelete={(url, i) => this.onRemoveInfoImage(url, i)}
								onSort={(val) => this.onSortInfoImage(val)}
								maxSize={2048}
								maxLen={16}
							/>
							{(!this.displayInfoImage || !this.displayInfoImage.length) && !this.pInfo.infoImage.isDefault && this.pInfo.productCode && <el-image src="https://ssl-picture.tenyun.runsasoft.com/wumorentu.png" style="width: 150px" />}
							{!!this.pInfo.infoImage.isDefault && [<div class="tip">注1: 建议图片分辨率为750*750px;</div>, <div class="tip">注2: 每张图片大小不超过2M,支持jpg、jpeg、png、gif,最多支持上传16张;</div>, <div class="tip">注3: 拖拽图片可排序。</div>]}
						</el-form-item>
						<el-form-item label="商品色图" prop="">
							<el-radio-group v-model={this.pInfo.colorImages.isDefault} onChange={(val) => this.colorImageChange(val)}>
								<el-radio label={0}>使用默认商品色图</el-radio>
								<el-radio label={1}>自行上传商品色图</el-radio>
							</el-radio-group>
							<div class="p-color-image-box">
								{this.dispalyColorImages.map((cImage, index) => {
									return (
										<div class="p-color-image-content" key={`U+${index}`}>
											<Upload
												fileList={false}
												noDelete={false}
												disabled={!this.pInfo.colorImages.isDefault}
												onImgUploadSuccess={(val) => this.uploadColorImageSuccess(val, index)}
												v-model={cImage.image}
												onSort={(val) => this.onSortColorImage(val, index)}
												maxSize={2048}
											/>
											<div class="inline-block wid-70 center">{this.productId ? cImage.colorName : this.getColorName(cImage.colorCode)}</div>
										</div>
									);
								})}
							</div>
							{(!this.dispalyColorImages || !this.dispalyColorImages.length) && !this.pInfo.colorImages.isDefault && this.pInfo.productCode && <el-image src="https://ssl-picture.tenyun.runsasoft.com/wumorentu.png" class="wid-75" />}
							{!!this.pInfo.colorImages.isDefault && [<div class="tip">注1: 建议图片分辨率为750*750px;</div>, <div class="tip">注2: 每张图片大小不超过2M,支持jpg、jpeg、png、gif;</div>]}
						</el-form-item>
						{showPlatform() && [
							<el-form-item label="赠品配置" prop="productType">
								<el-checkbox true-label={1} false-label={0} v-model={this.pInfo.productType}>
									设为赠品
								</el-checkbox>
							</el-form-item>,
							!!this.pInfo.productType && [
								<el-form-item label="获取赠品条件" prop="productConfig.minOrderPrice">
									<div class="row items-center">
										<el-checkbox v-model={this.productConfigOpen}></el-checkbox>
										<div class={["el-checkbox el-checkbox__label", this.productConfigOpen && "text-blue-15"]}>
											整单满
											<el-input class="wid-40 r-px-12" size="small" v-model={this.pInfo.productConfig.minOrderPrice} />
											元方可下单（需将赠品一并下单）
										</div>
									</div>
								</el-form-item>,
								<el-form-item prop="productConfig.cplId">
									<div>
										<el-checkbox v-model={this.hasCoupon}>顾客拥有指定礼品券</el-checkbox>
										{this.hasCoupon && (
											<div>
												<el-button type="primary" onClick={() => this.chooseCoupon()}>
													+ 添加优惠券
												</el-button>
											</div>
										)}
										{!!this.pInfo.productConfig.cplId && this.hasCoupon && (
											<CouponCard
												data={this.couponCardInfo}
												onRemove={() => {
													this.couponCardInfo = {};
													this.pInfo.productConfig.cplId = "";
												}}
											/>
										)}
									</div>
								</el-form-item>,
							],
						]}

						{this.productId ? (
							<div></div>
						) : (
							<el-form-item label="上下架状态" prop="">
								<el-radio-group v-model={this.pInfo.openState}>
									<el-radio label={1}>上架</el-radio>
									<el-radio label={0}>下架</el-radio>
								</el-radio-group>
							</el-form-item>
						)}
					</el-form>
				</div>
				<div class="bottomWrapper">
					<el-button type="primary" disabled={this.disabled} onClick={this.onSave.bind(this)}>
						{this.productId ? "保存" : "确认添加"}
					</el-button>
					<el-button onClick={this.onCancel.bind(this)}>取消</el-button>
				</div>
			</div>
		);
	}
}
